/**
 * Application constants and environment variables
 */

// Google API Configuration
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';
export const GOOGLE_PLACES_API_KEY = import.meta.env.VITE_GOOGLE_PLACES_API_KEY || '';
export const GOOGLE_PLACE_ID = import.meta.env.VITE_GOOGLE_PLACE_ID || '';

// Restaurant Information
export const RESTAURANT_INFO = {
  name: 'Restaurant Fey',
  address: 'Fey am Tibarg, Tibarg 16, 22459 Hamburg',
  coordinates: {
    lat: 53.618219,
    lng: 9.950745,
  },
} as const;

// Social Media Links
export const SOCIAL_LINKS = {
  instagram: '', // To be configured
  facebook: '', // To be configured
} as const;

// External Links
export const EXTERNAL_LINKS = {
  schluerfgold: 'https://schluerfgold.de/',
} as const;

// Responsive Breakpoints (matching Tailwind defaults)
export const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  desktop: 1280,
} as const;

// API Configuration
export const API_CONFIG = {
  reviewsCacheDuration: 3600000, // 1 hour in milliseconds
  requestTimeout: 10000, // 10 seconds
  maxRetries: 3,
} as const;

// Validate required environment variables
export const validateEnvVars = (): { isValid: boolean; missing: string[] } => {
  const required = [
    { key: 'VITE_GOOGLE_MAPS_API_KEY', value: GOOGLE_MAPS_API_KEY },
    { key: 'VITE_GOOGLE_PLACES_API_KEY', value: GOOGLE_PLACES_API_KEY },
    { key: 'VITE_GOOGLE_PLACE_ID', value: GOOGLE_PLACE_ID },
  ];

  const missing = required
    .filter(({ value }) => !value)
    .map(({ key }) => key);

  return {
    isValid: missing.length === 0,
    missing,
  };
};
